

(function() {
  'use strict';

  function init() {
    document.body.addEventListener('mouseenter', handleMouseEnter, true);
    document.body.addEventListener('mouseleave', handleMouseLeave, true);
  }

  function isEnteringOrLeavingWrapper(type, target, related) {
    const wrapper = target.closest('.card__media.card-product-media-wrapper-accessory');
    if (!wrapper) return null;
    if (!related) return wrapper; 
    const inside = wrapper.contains(related);
    if (type === 'enter' && inside) return null; 
    if (type === 'leave' && inside) return null; 
    return wrapper;
  }

  function handleMouseEnter(event) {
    const wrapper = isEnteringOrLeavingWrapper('enter', event.target, event.relatedTarget);
    if (!wrapper) return;
    const hoverImage = wrapper.querySelector('.accessory-hover-image');
    if (hoverImage) hoverImage.style.opacity = '1';
  }

  function handleMouseLeave(event) {
    const wrapper = isEnteringOrLeavingWrapper('leave', event.target, event.relatedTarget);
    if (!wrapper) return;
    const hoverImage = wrapper.querySelector('.accessory-hover-image');
    if (hoverImage) hoverImage.style.opacity = '0';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);

})();
